const externalPartnerAdminRoles = ['ROLE_USER_MANAGEMENT']

export default [
  {
    path: '/external-partners',
    name: 'external-partner-list',
    meta: {
      breadcrumb: [
        { text: 'partner-admin.menu.title' },
        { text: 'partner-admin.list.title', active: true },
      ],
      pageTitle: 'partner-admin.list.title',
      roles: externalPartnerAdminRoles,
      organizationFeature: 'partners',
    },
    component: () => import('@/views/external-partner/ExternalPartnerList'),
  },
  {
    path: '/external-partners/create',
    name: 'external-partner-create',
    meta: {
      breadcrumb: [
        { text: 'partner-admin.menu.title', to: '/external-partners' },
        { text: 'partner-admin.create.title', active: true },
      ],
      pageTitle: 'partner-admin.create.title',
      roles: externalPartnerAdminRoles,
      organizationFeature: 'partners',
    },
    component: () => import('@/views/external-partner/ExternalPartnerEdit'),
  },
  {
    path: '/external-partners/:id',
    name: 'external-partner-details',
    meta: {
      breadcrumb: [
        { text: 'partner-admin.menu.title', to: '/external-partners' },
        { text: 'partner-admin.details.title', active: true },
      ],
      pageTitle: 'partner-admin.details.title',
      roles: externalPartnerAdminRoles,
      organizationFeature: 'partners',
    },
    component: () => import('@/views/external-partner/ExternalPartnerEdit'),
  },
]
